jQuery(document).ready(function($) {

	$.quantity = {
		init: function() {
			$.quantity.build();
			$.quantity.events();
		},

		build: function() {
			jQuery('<div class="m-form-products__quantity-nav"><div class="m-form-products__quantity-button quantity-up"></div><div class="m-form-products__quantity-button quantity-down"></div></div>').insertAfter('.m-form-products__quantity input');

			jQuery('.m-form-products__quantity').each(function() {
				var spinner = jQuery(this),
					input = spinner.find('input[type="number"]'),
					btnUp = spinner.find('.quantity-up'),
					btnDown = spinner.find('.quantity-down'),
					min = input.attr('min'),
					max = input.attr('max');

				btnUp.click(function() {
					var oldValue = parseFloat(input.val());
					if (oldValue >= max) {
						var newVal = oldValue;
					} else {
						var newVal = oldValue + 1;
					}
					spinner.find("input").val(newVal);
					spinner.find("input").trigger("change");
				});

				btnDown.click(function() {
					var oldValue = parseFloat(input.val());
					if (oldValue <= min) {
						var newVal = oldValue;
					} else {
						var newVal = oldValue - 1;
					}
					spinner.find("input").val(newVal);
					spinner.find("input").trigger("change");
				});

			});
		},

		process: function(that) {
			var sQuantity = that.closest('input').val();
			var sPrice = that.closest('input').attr('data-price');
			var sResult = formatMoney(parseFloat(sQuantity) * parseFloat(sPrice));

			$('.m-form-products__result', that.parents('.m-form-products__trigger')).val(sResult + ' €');
		},

		prepareResult: function() {
			var sResult = '';
			var sSum = 0.00;

			$('.m-form-products__trigger').each(function() {
				var sQuantity = $('.m-form-products__quantity input', $(this)).val();
				if (sQuantity > 0) {
					sResult += 'Produkt: ' + $('.m-form-products__title', $(this)).text() + '\n';
					sResult += 'Beschreibung: ' + $('.m-form-products__description', $(this)).text() + '\n';
					sResult += 'Preis: ' + $('.m-form-products__price', $(this)).text() + '\n';
					sResult += 'Menge: ' + sQuantity + '\n';
					sResult += 'Gesamtpreis: ' + $('.m-form-products__result', $(this)).val() + '\n\n';
					sResult += '-------------------------------------------------------------------------------\n\n';

					var sCurrent = parseFloat(sSum.toString().replace(/\./g, '').replace(',', '.'));
					var sNew = parseFloat($('.m-form-products__result', $(this)).val().replace(/\./g, '').replace(',', '.'));

					console.log(sCurrent);
					console.log(sNew);

					sSum = formatMoney(sCurrent + sNew);
				}
			});

			sResult += 'Summe:' + sSum + ' € + MwSt.';
			$('.m-form-products__sum').text(sSum + ' € + MwSt.');
			$('.wpcf7-form-control-wrap.nachricht textarea').val(sResult);
		},

		events: function() {
			$('.m-form-products__quantity input').on('keyup', function() {
				$.quantity.process($(this));
				$.quantity.prepareResult();
			}).change(function() {
				$.quantity.process($(this));
				$.quantity.prepareResult();
			});

			$('.m-product-form form').submit(function(e) {
			});
		}

	}

	function formatMoney(n, c, d, t) {
		var c = isNaN(c = Math.abs(c)) ? 2 : c,
			d = d == undefined ? "," : d,
			t = t == undefined ? "." : t,
			s = n < 0 ? "-" : "",
			i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			j = (j = i.length) > 3 ? j % 3 : 0;

		return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
	};
});